export enum StatusCodes {
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  SERVICE_UNAVAILABLE = 503,
}
